import React from 'react';
import PropTypes from 'prop-types';
import ChannelKey from '@avtechsoftware/ra-javascript-utilities/src/classes/ChannelKey';
import {
  CELSIUS_ID,
  FAHRENHEIT_ID,
} from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelValueRender';
import AlertRowTimestamp from '../AlertRowTimestamp/AlertRowTimestamp';
import getChannelValueWithUnitsFromChannelKeyObjectString
  from '../../../../../common/ChannelValueWithUnitsFromChannelKeyObject/getChannelValueWithUnitsFromChannelKeyObjectString';

/* istanbul ignore next */
function AlertRowLastReadingBadge({
  isSuspended,
  isDeviceSuspended,
  lastReading,
  lastReadingTimestamp,
  isTriggered,
  triggeredTimestamp,
  isAcknowledged,
  channelKeyObj,
  customUnit,
  temperatureScale,
}) {
  const getDisplayBadgeColor = () => {
    let color = '#28a745';
    if (isTriggered) {
      color = isAcknowledged ? '#ff751f' : '#dc3545';
    }
    return color;
  };

  if (isSuspended) {
    return (
      <>
        <span
          className="badge badge-secondary"
          style={{ fontSize: '12px' }}
        >
          Alert Suspended
        </span>
        <AlertRowTimestamp lastReadingTimestamp={lastReadingTimestamp} />
      </>
    );
  }
  if (isDeviceSuspended) {
    return (
      <>
        <span
          className="badge badge-secondary"
          style={{ fontSize: '12px' }}
        >
          Device Suspended
        </span>
        <AlertRowTimestamp lastReadingTimestamp={lastReadingTimestamp} />
      </>
    );
  }

  return (
    <>
      <span
        style={{ backgroundColor: getDisplayBadgeColor(), fontSize: '12px' }}
        className="badge text-white font-weight-bold"
      >
        {getChannelValueWithUnitsFromChannelKeyObjectString(
          temperatureScale,
          channelKeyObj,
          lastReading,
          customUnit,
        )}
      </span>
      <AlertRowTimestamp
        lastReadingTimestamp={isTriggered ? triggeredTimestamp : lastReadingTimestamp}
      />
    </>
  );
}

AlertRowLastReadingBadge.defaultProps = {
  triggeredTimestamp: null,
  temperatureScale: CELSIUS_ID,
};

AlertRowLastReadingBadge.propTypes = {
  isSuspended: PropTypes.bool.isRequired,
  isDeviceSuspended: PropTypes.bool.isRequired,
  lastReading: PropTypes.string.isRequired,
  lastReadingTimestamp: PropTypes.number.isRequired,
  isTriggered: PropTypes.bool.isRequired,
  triggeredTimestamp: PropTypes.number,
  isAcknowledged: PropTypes.bool.isRequired,
  channelKeyObj: PropTypes.instanceOf(ChannelKey).isRequired,
  // eslint-disable-next-line react/require-default-props
  customUnit: PropTypes.string,
  temperatureScale: PropTypes.oneOf([CELSIUS_ID, FAHRENHEIT_ID]),
};

export default AlertRowLastReadingBadge;
